import { ACCESS_COOKIE_NAME, ACCESS_TOKEN, REFRESH_TOKEN } from '@pequity/shared/types/constants';
import { clearIsiSessionId, clearIsOidcSession } from '@pequity/shared/utils/oidc';
import { PEQUITY_SOCKET_PROTOCOL } from '@/types/environment';

export const getUrlBase = () => {
  const protocol = window.location.protocol + '//';
  const split = window.location.host.split(':');
  const newHost = split.length > 1 ? split[0] + ':8000' : split[0];
  return protocol + newHost;
};

const URL_BASE = getUrlBase();

export const WEBSOCKETS_URL = `${PEQUITY_SOCKET_PROTOCOL}://${new URL(URL_BASE).host}/ws`;

const setAccessCookie = (cookie: string) => {
  document.cookie = `${ACCESS_COOKIE_NAME}=${cookie}; path=/;`;
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  setAccessCookie('');
  localStorage.removeItem(REFRESH_TOKEN);
  clearIsOidcSession();
  clearIsiSessionId();
};

type AimLogoutParams = {
  accessToken: string;
  logoutEndpoint: string;
  clientId: string;
  redirectUri?: string;
};

export const submitAimLogoutForm = ({ accessToken, logoutEndpoint, clientId, redirectUri }: AimLogoutParams) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = logoutEndpoint;

  const fields: Record<string, string> = {
    token_type_hint: 'access_token',
    token: accessToken,
    post_logout_redirect_uri: redirectUri ?? `${window.location.origin}/v3/logged-out`,
    trans_id: 'pequity-oidc',
    client_id: clientId,
  };

  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
};

export const setRefreshToken = (token: string) => {
  localStorage.setItem(REFRESH_TOKEN, token);
};
